import React from 'react';
import { Link } from '@qred/components-library';
import useTranslate from './useTranslate';
import { LoanType } from '@qred/shared-enums';
import useLoanLinks from './links/useLoanLinks';

interface UseLoanConsentTextParams {
  loanType: LoanType;
}

const useLoanConsentText = ({ loanType }: UseLoanConsentTextParams) => {
  const t = useTranslate();
  const {
    openGeneralTerms,
    openProductTerms,
    openPriceList,
    productTermsLinkText,
  } = useLoanLinks(loanType);

  const generalTermsLink = (
    <Link size="sm" onClick={openGeneralTerms}>
      {t('OnboardingOffer.TermsAndConditionslinkText')}
    </Link>
  );

  const productTermsLink = (
    <Link size="sm" onClick={openProductTerms}>
      {productTermsLinkText}
    </Link>
  );

  const priceListingLink = (
    <Link size="sm" onClick={openPriceList}>
      {t('OnboardingOffer.PriceListingLinkText')}
    </Link>
  );

  const formattedLinksText = (
    <>
      {generalTermsLink}, {productTermsLink} {t('OnboardingOffer.And')}{' '}
      {priceListingLink}
    </>
  );

  return t('OnboardingOffer.TermsAndConditionsConsent', {
    termsAndConditionslinkText: formattedLinksText,
  });
};

export default useLoanConsentText;
